import React, { useContext, useEffect, useRef, useState } from 'react'
import axios from 'axios'
import { baseUrl, path } from '../../constants'
import { Oval } from 'react-loader-spinner'
import { useLocation, useNavigate } from "react-router-dom";
import { appContext } from '../../Context/appProvider'
import { api } from '../../api';

export default function AddCategory({  }) {
    const location = useLocation();
    const { category } = location.state || {};
     const [uploading, setUploading] = useState(false)
     const [sources, setSources] = useState()
     const [files, setFiles] = useState([])
     const [isSubmitting, setIsSubmitting] = useState(false)
     const [name, setName] = useState(category?.name)
     const fileRef = useRef()
     const {setNotification} = useContext(appContext)
     const navigate = useNavigate()

     const uploadImage = (event) => {
        setFiles([event.target.files[0]])
     }

     const submit = () => {
        setIsSubmitting(true)
        api(category ? path.editCategory : path.addCategory, {
            method: category ? 'patch' : 'post',
            data: {
                name, image: sources, id: category?.id
            }
        }).then(response => {
            setIsSubmitting(false)
            if(response.data.success){
                setNotification({
                    message: 'Category successfully ' + category ? 'updated' : 'created',
                    visible: true,
                    type: 'success'
                })
                navigate(-1)
            }
        }).catch(e => {
            setIsSubmitting(false)
            setNotification({
                message: 'Unkown error occured!',
                visible: true,
                type: 'error'
            })
        })
     }

    return (
    <div className='flex flex-col gap-5 h-full w-full bg-white rounded-sm p-4'>
        <h2 className='text-black text-[18px] font-bold'>{category ? 'Edit' : 'Add'} Category</h2>
        <div className='flex flex-col gap-3'>
            <div className='flex flex-col gap-3 w-fit'>
                <div className='flex gap-2 items-center'>
                    <input ref={fileRef} onChange={uploadImage} type='file' className='border-solid border-[1px] border-[#00000040] p-2' />
                    <button onClick={() => fileRef.current?.click()} className={`bg-black p-2 text-[12px] text-white`}>Change</button>
                </div>
                <div className='flex flex-wrap gap-2'>
                    {files.map(file => (
                        <UploadItem file={file} setUploading={setUploading} setSources={setSources} />
                    ))}
                </div>
                <input onChange={event => setName(event.target.value)} placeholder='Category Name' type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-full' value={name} />
                <button onClick={submit} disabled={isSubmitting || uploading || (!category && !name)} type='submit' className={`${((!sources && !category ) || uploading || (!category && !name)) ? 'bg-[#a3a3a3]' : 'bg-main'} text-white text-[14px] w-full p-2 flex items-center justify-center`}>
                {isSubmitting ? (
                    <Oval
                        visible={true}
                        height="21"
                        width="21"
                        color="#198754"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        strokeWidth={3}
                    />
                ) : 'Save'}
                </button>
            </div>
        </div>
    </div>
    )
}

function UploadItem({ file, setUploading, setSources }){
    const [loading, setLoading] = useState(true)
    const [source, setSource] = useState(null)

    useEffect(() => {
        setLoading(true)
        let form  = new FormData()
        form.append('file', file)
        console.log(file)
        axios(baseUrl + path.uploadFile + '?to=images', {
            data: form,
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            if(response.data.success){
                setLoading(false)
                setSource(response.data.source)
                setSources(response.data.source)
            }
        })
    }, [file])

    return (
        <div className='w-[50px] h-[50px] border-[#00000050] border-solid border-[1px] p-1 flex items-center justify-center'>
            {loading ? (
                <Oval
                    visible={true}
                    height="24"
                    width="25"
                    color="#198754"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    strokeWidth={3}
                /> ): (
                    <img src={baseUrl + source} alt='source' className='w-full h-full object-contain'  />
                )}
        </div>
    )
}